import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent implements OnInit {
  @Input() public errorMessage?: string;

  constructor(
    private dialogRef: DialogRef,
    private santizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  public getTrustedErrorHtml(): any {
    return this.santizer.sanitize(SecurityContext.HTML, this.errorMessage ?? '');
  }

  public close(): void {
    this.dialogRef.close();
  }
}
